// Last-known-good snapshot of StringsSG aircon job statistics per locality.
//
// WHY THIS FILE EXISTS
// The 26 /sg/aircon-servicing-singapore/locality/{area} pages fetch live
// aggregates at build time from /public/GetAirconLocalityStats. If that call
// fails the pages must still render, so this committed snapshot is the
// fallback. The figures are what make each locality page different from the
// other 25 - they describe work StringsSG actually did in that area.
//
// HOW TO REFRESH IT
// Re-call the endpoint and paste the response below. Do NOT hand-edit the
// figures: an invented share or band is worse than no section. ready: false
// hides every statistic on every locality page.
//
// Captured from production on 2026-09-27 (asOf 2026-09-27T08:08:15.935903757Z), after the
// backend began learning postal sectors from job addresses (SectorAreaService).
//
// PRIVACY: aggregates only, and no exact counts - the backend floors job counts
// to a band ("40+") and rounds shares to 5%. Keep it that way here.

export const airconLocalityStatsSnapshot = {
    "ready": true,
    "asOf": "2026-09-27T08:08:15.935903757Z",
    "windowStart": "2022-12-27",
    "minSample": 20,
    "singapore": {
        "name": "Singapore",
        "ready": true,
        "jobsBand": "9,300+",
        "serviceMix": [
            {
                "label": "General Servicing",
                "share": 80
            },
            {
                "label": "Gas Top Up",
                "share": 15
            },
            {
                "label": "Chemical Wash",
                "share": 10
            },
            {
                "label": "Condenser Cleaning",
                "share": 10
            },
            {
                "label": "Aircon Repair",
                "share": 10
            },
            {
                "label": "Chemical Overhaul",
                "share": 5
            },
            {
                "label": "Drain Pipe Flush",
                "share": 5
            }
        ],
        "oneTimeShare": 90,
        "packageShare": 10,
        "medianUnits": 3,
        "ceilingShare": 0,
        "medianOneTimeCost": 80
    },
    "localities": [
        {
            "name": "Ang Mo Kio",
            "ready": true,
            "jobsBand": "200+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 75
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Gas Top Up",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 85,
            "packageShare": 15,
            "medianUnits": 2,
            "ceilingShare": 0,
            "medianOneTimeCost": 66
        },
        {
            "name": "Bedok",
            "ready": true,
            "jobsBand": "400+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 85,
            "packageShare": 15,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 76
        },
        {
            "name": "Bishan",
            "ready": true,
            "jobsBand": "100+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Gas Top Up",
                    "share": 20
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 84
        },
        {
            "name": "Bukit Batok",
            "ready": true,
            "jobsBand": "250+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 75
        },
        {
            "name": "Bukit Panjang",
            "ready": true,
            "jobsBand": "250+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 83
        },
        {
            "name": "Clementi",
            "ready": true,
            "jobsBand": "300+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 85,
            "packageShare": 15,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 80
        },
        {
            "name": "Eunos",
            "ready": true,
            "jobsBand": "150+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 75
        },
        {
            "name": "Geylang",
            "ready": true,
            "jobsBand": "150+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 2,
            "ceilingShare": 0,
            "medianOneTimeCost": 71
        },
        {
            "name": "Hougang",
            "ready": true,
            "jobsBand": "300+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 75
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 85,
            "packageShare": 15,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 78
        },
        {
            "name": "Jurong East",
            "ready": true,
            "jobsBand": "150+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 75
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Aircon Repair",
                    "share": 15
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 80
        },
        {
            "name": "Little India",
            "ready": true,
            "jobsBand": "70+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 90
                },
                {
                    "label": "Gas Top Up",
                    "share": 20
                },
                {
                    "label": "Chemical Wash",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 2,
            "ceilingShare": 0,
            "medianOneTimeCost": 71
        },
        {
            "name": "Marine Parade",
            "ready": true,
            "jobsBand": "250+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 75
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                }
            ],
            "oneTimeShare": 80,
            "packageShare": 20,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 83
        },
        {
            "name": "Orchard",
            "ready": true,
            "jobsBand": "150+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 85,
            "packageShare": 15,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 91
        },
        {
            "name": "Pasir Ris",
            "ready": true,
            "jobsBand": "250+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 85,
            "packageShare": 15,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 89
        },
        {
            "name": "Paya Lebar",
            "ready": true,
            "jobsBand": "30+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 90
                },
                {
                    "label": "Gas Top Up",
                    "share": 25
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 20
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 95,
            "packageShare": 5,
            "medianUnits": 4,
            "ceilingShare": 0,
            "medianOneTimeCost": 93
        },
        {
            "name": "Raffles Place",
            "ready": true,
            "jobsBand": "80+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 85
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Gas Top Up",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                }
            ],
            "oneTimeShare": 80,
            "packageShare": 20,
            "medianUnits": 3,
            "ceilingShare": 5,
            "medianOneTimeCost": 84
        },
        {
            "name": "Rochor",
            "ready": true,
            "jobsBand": "50+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 75
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                }
            ],
            "oneTimeShare": 95,
            "packageShare": 5,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 66
        },
        {
            "name": "Sengkang",
            "ready": true,
            "jobsBand": "450+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 75
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 15
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 81
        },
        {
            "name": "Sentosa",
            "ready": false,
            "serviceMix": []
        },
        {
            "name": "Serangoon",
            "ready": true,
            "jobsBand": "150+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Gas Top Up",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Wash",
                    "share": 5
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 80
        },
        {
            "name": "Tampines",
            "ready": true,
            "jobsBand": "400+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 75
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 84
        },
        {
            "name": "Tanglin",
            "ready": true,
            "jobsBand": "200+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 85
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Gas Top Up",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 80
        },
        {
            "name": "Tanjong Pagar",
            "ready": true,
            "jobsBand": "100+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 90
                },
                {
                    "label": "Chemical Wash",
                    "share": 10
                },
                {
                    "label": "Gas Top Up",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 5
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                },
                {
                    "label": "Aircon Repair",
                    "share": 5
                }
            ],
            "oneTimeShare": 90,
            "packageShare": 10,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 75
        },
        {
            "name": "Toa Payoh",
            "ready": true,
            "jobsBand": "350+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 80
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Gas Top Up",
                    "share": 15
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                }
            ],
            "oneTimeShare": 85,
            "packageShare": 15,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 80
        },
        {
            "name": "Woodlands",
            "ready": true,
            "jobsBand": "300+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 75
                },
                {
                    "label": "Gas Top Up",
                    "share": 20
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 5
                }
            ],
            "oneTimeShare": 95,
            "packageShare": 5,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 80
        },
        {
            "name": "Yishun",
            "ready": true,
            "jobsBand": "350+",
            "serviceMix": [
                {
                    "label": "General Servicing",
                    "share": 70
                },
                {
                    "label": "Gas Top Up",
                    "share": 20
                },
                {
                    "label": "Chemical Wash",
                    "share": 15
                },
                {
                    "label": "Chemical Overhaul",
                    "share": 10
                },
                {
                    "label": "Condenser Cleaning",
                    "share": 10
                },
                {
                    "label": "Aircon Repair",
                    "share": 10
                },
                {
                    "label": "Drain Pipe Flush",
                    "share": 5
                }
            ],
            "oneTimeShare": 95,
            "packageShare": 5,
            "medianUnits": 3,
            "ceilingShare": 0,
            "medianOneTimeCost": 89
        }
    ],
    "unplacedShare": 14
}

// Gate for the whole dataset. A partially filled response degrades to the
// pages' existing content instead of publishing blanks.
export const hasAirconLocalityStats = (stats) =>
    Boolean(
        stats &&
        stats.ready &&
        stats.singapore?.ready &&
        stats.windowStart &&
        Array.isArray(stats.localities)
    )

// "1,200+" -> 1200. Band floors are the only volume figure the API publishes.
export const bandFloor = (band) => Number(String(band ?? '').replace(/[^\d]/g, '')) || 0

// Names of the busiest localities by band floor. Ties at the cut-off are all
// included, since the bands cannot separate them.
export const getBusiestLocalities = (stats, count = 5) => {
    if (!hasAirconLocalityStats(stats)) return []
    const published = stats.localities.filter((r) => r?.ready && r.jobsBand)
    const floors = published.map((r) => bandFloor(r.jobsBand)).sort((a, b) => b - a)
    const cutOff = floors[Math.min(count, floors.length) - 1]
    return cutOff ? published.filter((r) => bandFloor(r.jobsBand) >= cutOff).map((r) => r.name) : []
}

// The published row for one locality, or null when it is below the minimum
// sample (the backend returns such rows with ready: false and no figures).
export const getLocalityStatsRow = (stats, locality) => {
    if (!hasAirconLocalityStats(stats)) return null
    const row = stats.localities.find((r) => r?.name === locality)
    return row?.ready && row.jobsBand ? row : null
}
